import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { AnalyticsTabs, AnalyticsTab } from '../components/analytics/AnalyticsTabs';
import { EmptyState } from '../components/analytics/EmptyState';
import { AcceptanceTab } from '../components/analytics/AcceptanceTab';
import { AuthenticationTab } from '../components/analytics/AuthenticationTab';
import { DisputesTab } from '../components/analytics/DisputesTab';
import { PaymentMethodsTab } from '../components/analytics/PaymentMethodsTab';
import { RefundsTab } from '../components/analytics/RefundsTab';
import { FeedbackModal } from '../components/analytics/FeedbackModal';
import { Granularity } from '../components/dashboard/GranularitySelector';
interface DateRange {
  start: Date;
  end: Date;
}
export function PaymentAnalytics() {
  const navigate = useNavigate();
  const location = useLocation();
  const getInitialTab = (): AnalyticsTab => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab') as AnalyticsTab;
    return tab || 'acceptance';
  };
  const [activeTab, setActiveTab] = useState<AnalyticsTab>(getInitialTab());
  const [dateRange, setDateRange] = useState<DateRange>({
    start: new Date(new Date().setDate(new Date().getDate() - 90)),
    end: new Date()
  });
  const [granularity, setGranularity] = useState<Granularity>('weekly');
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set('tab', activeTab);
    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true
    });
  }, [activeTab]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab') as AnalyticsTab;
    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    }
  }, [location.search]);
  const handleTabChange = (tab: AnalyticsTab) => {
    setActiveTab(tab);
  };
  const renderTabContent = () => {
    const contentVariants = {
      initial: {
        opacity: 0,
        y: 10
      },
      animate: {
        opacity: 1,
        y: 0
      },
      exit: {
        opacity: 0,
        y: -10
      }
    };
    return <AnimatePresence mode="wait" data-id="element-9725">
        <motion.div key={activeTab} variants={contentVariants} initial="initial" animate="animate" exit="exit" transition={{
        duration: 0.2
      }} data-id="element-9726">
          {activeTab === 'acceptance' ? <AcceptanceTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-9727" /> : activeTab === 'authentication' ? <AuthenticationTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-9728" /> : activeTab === 'disputes' ? <DisputesTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-9729" /> : activeTab === 'payment-methods' ? <PaymentMethodsTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-9730" /> : activeTab === 'refunds' ? <RefundsTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-9731" /> : <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-9732">
              <EmptyState message={`${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} analytics content coming soon`} submessage="This section will display detailed analytics charts and tables." data-id="element-9733" />
            </div>}
        </motion.div>
      </AnimatePresence>;
  };
  return <div data-id="element-9734">
      <div className="mb-6" data-id="element-9735">
        <div className="flex items-center justify-between mb-4" data-id="element-9736">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-9737">
            Payment analytics
          </h1>
          <button onClick={() => setShowFeedbackModal(true)} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-9738">
            Share feedback
          </button>
        </div>
        <AnalyticsTabs activeTab={activeTab} onChange={handleTabChange} data-id="element-9739" />
      </div>

      <div data-id="element-9740">{renderTabContent()}</div>

      <FeedbackModal isOpen={showFeedbackModal} onClose={() => setShowFeedbackModal(false)} data-id="element-9741" />
    </div>;
}